import React, { useState } from 'react';

import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';

import type { CreateTagInput } from '~/services/TagsService';

import type { AssignmentFormData } from './TagAssignments/TagAssignments';
import TagForm, { type FormTag } from './TagForm';
import { useCreateTag } from './hooks';

export default function TagCreate({ onBack }: { onBack: () => void }) {
  const [tab, setTab] = useState('assignments');
  const [assignments, setAssignments] = useState<Array<AssignmentFormData>>([]);
  const { enqueueSnackbar } = useSnackbar();

  const createTag = useCreateTag();

  const { control, handleSubmit } = useForm<FormTag>({
    defaultValues: {
      name: '',
      schedules: [],
    },
  });

  const onSubmit = async (data: FormTag) => {
    if (assignments.length === 0) {
      enqueueSnackbar('Please add at least one assignment before creating the tag', { variant: 'error' });
      return;
    }
    const createData: CreateTagInput = {
      name: data.name,
      assignments: assignments.map((assignment) => ({
        entityType: assignment.entityType,
        entityId: assignment.entityId,
      })),
      schedules: data.schedules.map((schedule) => ({
        brands: schedule.brands,
        activeStartDate: schedule.activeStartDate,
        activeEndDate: schedule.activeEndDate,
      })),
    };
    await createTag.mutateAsync(createData);
    onBack();
  };

  return (
    <TagForm
      mode="create"
      tab={tab}
      control={control}
      isSaving={createTag.isPending}
      assignments={assignments}
      onAssignmentsChange={setAssignments}
      onBack={onBack}
      onSave={handleSubmit(onSubmit)}
      onTabChange={setTab}
    />
  );
}
